module.exports = __webpack_public_path__ + "static/media/7_l_stena_0_0.95c15979.png";